export const RECTIFICATION_APPROVAL = '/rectification_approval/';
export const PUT_RECTIFICATION_APPROVAL = id =>
  `/rectification_approval/${id}/`;
